<app-header-latest></app-header-latest>
<!-- HERO -->
<div class="mfg-hero">
  <div class="container-wrapper">
    <div>
      <div class="section-eyebrow">🏭 INDUSTRIAL WORKFORCE</div>
      <h1>Shift-Ready HR<br>for <span style="color:#FB923C;">Factory Floors</span></h1>
      <p>Manage multi-shift rosters, biometric clock-ins, overtime compliance, and plant-wide payroll — built for manufacturing operations at any scale.</p>
      <div style="display:flex;gap:16px;flex-wrap:wrap;">
        <a href="#" class="btn btn-primary" style="background:#c2410c;">Schedule a Demo</a>
        <a href="#" class="btn btn-outline" style="color:#fff;border-color:rgba(255,255,255,0.3);">See Shift Features</a>
      </div>
    </div>
    <div>
      <div class="mfg-clock-widget">
        <div class="fingerprint-icon">🏭</div>
        <div class="biometric-status">⚡ Plant B — Line 3 Active</div>
        <div style="color:rgba(255,255,255,0.6);font-size:13px;margin-top:8px;">142 / 148 workers clocked in</div>
        <div style="margin-top:24px;display:grid;grid-template-columns:repeat(3,1fr);gap:12px;">
          <div style="text-align:center;background:rgba(255,255,255,0.07);border-radius:8px;padding:14px 8px;">
            <div style="font-size:22px;font-weight:900;color:#fff;">6am</div>
            <div style="font-size:10px;color:rgba(255,255,255,0.5);margin-top:4px;">Morning Shift</div>
          </div>
          <div style="text-align:center;background:rgba(255,255,255,0.07);border-radius:8px;padding:14px 8px;">
            <div style="font-size:22px;font-weight:900;color:#fff;">2pm</div>
            <div style="font-size:10px;color:rgba(255,255,255,0.5);margin-top:4px;">Afternoon Shift</div>
          </div>
          <div style="text-align:center;background:rgba(255,255,255,0.07);border-radius:8px;padding:14px 8px;">
            <div style="font-size:22px;font-weight:900;color:#fff;">10pm</div>
            <div style="font-size:10px;color:rgba(255,255,255,0.5);margin-top:4px;">Night Shift</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- SHIFT MATRIX -->
<section class="matrix-section">
  <div class="container-wrapper">
    <div class="sec-head">
      <span class="section-eyebrow">📋 Shift Planning</span>
      <h2 class="sec-h2">Visual Shift Matrix<br><span class="gradient-text">Across All Plants</span></h2>
      <p class="sec-sub">Plan, publish, and swap shifts across departments and floors with drag-and-drop simplicity and automatic conflict detection.</p>
    </div>
    <table class="matrix-table">
      <thead>
        <tr>
          <th class="matrix-th">Employee</th>
          <th class="matrix-th">Department</th>
          <th class="matrix-th">Monday</th>
          <th class="matrix-th">Tuesday</th>
          <th class="matrix-th">Wednesday</th>
          <th class="matrix-th">Thursday</th>
          <th class="matrix-th">Friday</th>
        </tr>
      </thead>
      <tbody>
        <tr class="matrix-row">
          <td class="matrix-td">Ravi Kumar</td>
          <td class="matrix-td">Assembly Line A</td>
          <td class="matrix-td"><span class="shift-badge morning">Morning</span></td>
          <td class="matrix-td"><span class="shift-badge morning">Morning</span></td>
          <td class="matrix-td"><span class="shift-badge afternoon">Afternoon</span></td>
          <td class="matrix-td"><span class="shift-badge afternoon">Afternoon</span></td>
          <td class="matrix-td"><span class="shift-badge morning">Morning</span></td>
        </tr>
        <tr class="matrix-row">
          <td class="matrix-td">Priya Singh</td>
          <td class="matrix-td">Quality Control</td>
          <td class="matrix-td"><span class="shift-badge afternoon">Afternoon</span></td>
          <td class="matrix-td"><span class="shift-badge night">Night</span></td>
          <td class="matrix-td"><span class="shift-badge night">Night</span></td>
          <td class="matrix-td"><span class="shift-badge morning">Morning</span></td>
          <td class="matrix-td"><span class="shift-badge morning">Morning</span></td>
        </tr>
        <tr class="matrix-row">
          <td class="matrix-td">James Okafor</td>
          <td class="matrix-td">Packaging Unit</td>
          <td class="matrix-td"><span class="shift-badge night">Night</span></td>
          <td class="matrix-td"><span class="shift-badge night">Night</span></td>
          <td class="matrix-td"><span class="shift-badge morning">Morning</span></td>
          <td class="matrix-td"><span class="shift-badge night">Night</span></td>
          <td class="matrix-td"><span class="shift-badge afternoon">Afternoon</span></td>
        </tr>
        <tr class="matrix-row">
          <td class="matrix-td">Chen Wei</td>
          <td class="matrix-td">Welding Section</td>
          <td class="matrix-td"><span class="shift-badge morning">Morning</span></td>
          <td class="matrix-td"><span class="shift-badge afternoon">Afternoon</span></td>
          <td class="matrix-td"><span class="shift-badge morning">Morning</span></td>
          <td class="matrix-td"><span class="shift-badge night">Night</span></td>
          <td class="matrix-td"><span class="shift-badge night">Night</span></td>
        </tr>
      </tbody>
    </table>
  </div>
</section>

<!-- FATIGUE RULES -->
<section class="fatigue-section">
  <div class="container-wrapper">
    <div class="sec-head">
      <span class="section-eyebrow">🛡️ Worker Safety</span>
      <h2 class="sec-h2">Automated Fatigue &amp;<br><span class="gradient-text">Safety Rules</span></h2>
      <p class="sec-sub">Protect your workforce with intelligent rules that prevent dangerous overwork and enforce mandatory rest periods automatically.</p>
    </div>
    <div class="fatigue-grid">
      <div class="fatigue-card">
        <div class="fatigue-card__icon">⏰</div>
        <div class="fatigue-card__title">Max Hours Enforcement</div>
        <div class="fatigue-card__desc">Automatically block scheduling more than 12 consecutive hours or 60 weekly hours per worker — alerts supervisors before publication.</div>
        <div class="fatigue-card__badge">OSHA Compliant</div>
      </div>
      <div class="fatigue-card">
        <div class="fatigue-card__icon">💤</div>
        <div class="fatigue-card__title">Mandatory Rest Periods</div>
        <div class="fatigue-card__desc">Enforce minimum 8-hour gaps between shifts with a rule engine that flags violations before they cause safety incidents.</div>
        <div class="fatigue-card__badge">ILO Standard</div>
      </div>
      <div class="fatigue-card">
        <div class="fatigue-card__icon">🔁</div>
        <div class="fatigue-card__title">Night Shift Rotation</div>
        <div class="fatigue-card__desc">Smart rotation rules ensure no worker is locked to night shifts indefinitely, balancing fatigue exposure across the entire team.</div>
        <div class="fatigue-card__badge">Auto-Balanced</div>
      </div>
      <div class="fatigue-card">
        <div class="fatigue-card__icon">📊</div>
        <div class="fatigue-card__title">Overtime Analytics</div>
        <div class="fatigue-card__desc">Real-time dashboards showing department-level overtime trends, cost variance, and compliance exposure before payroll runs.</div>
        <div class="fatigue-card__badge">Live Dashboard</div>
      </div>
      <div class="fatigue-card">
        <div class="fatigue-card__icon">🚨</div>
        <div class="fatigue-card__title">Incident Early Warning</div>
        <div class="fatigue-card__desc">ML-powered alerts flag high-fatigue individuals based on consecutive shifts, absenteeism patterns, and workload history.</div>
        <div class="fatigue-card__badge">AI-Powered</div>
      </div>
      <div class="fatigue-card">
        <div class="fatigue-card__icon">📋</div>
        <div class="fatigue-card__title">Audit-Ready Logs</div>
        <div class="fatigue-card__desc">Every clock-in, shift change, and overtime approval is logged with timestamps for labor inspection and insurance reporting.</div>
        <div class="fatigue-card__badge">Audit Ready</div>
      </div>
    </div>
  </div>
</section>

<!-- COMPLIANCE -->
<section class="mfg-compliance">
  <div class="container-wrapper">
    <div class="sec-head">
      <span class="section-eyebrow">⚖️ Labor Compliance</span>
      <h2 class="sec-h2">Stay Audit-Proof<br><span class="gradient-text">Across Every Regulation</span></h2>
      <p class="sec-sub">Built-in compliance engine keeps your manufacturing operations aligned with Factory Act, ESI, PF, and global labor standards.</p>
    </div>
    <div class="mfg-comp-grid">
      <div class="mfg-comp-card">
        <div class="mfg-comp-card__icon">🏛️</div>
        <div>
          <div class="mfg-comp-card__title">Factory Act Compliance</div>
          <div class="mfg-comp-card__desc">Automatic enforcement of statutory working hour caps, mandatory breaks, and weekly off rules per the Factories Act — jurisdiction-aware for every plant location.</div>
        </div>
      </div>
      <div class="mfg-comp-card">
        <div class="mfg-comp-card__icon">🧾</div>
        <div>
          <div class="mfg-comp-card__title">ESI &amp; PF Calculations</div>
          <div class="mfg-comp-card__desc">Automated ESI and Provident Fund deductions calculated per employee based on current wage ceilings, with challan generation for government submissions.</div>
        </div>
      </div>
      <div class="mfg-comp-card">
        <div class="mfg-comp-card__icon">📑</div>
        <div>
          <div class="mfg-comp-card__title">Hazard Pay Policies</div>
          <div class="mfg-comp-card__desc">Configure role-specific hazard pay tiers, risk allowances, and safety certifications — automatically reflected in wage calculations every payroll cycle.</div>
        </div>
      </div>
      <div class="mfg-comp-card">
        <div class="mfg-comp-card__icon">🔒</div>
        <div>
          <div class="mfg-comp-card__title">Union Agreement Engine</div>
          <div class="mfg-comp-card__desc">Upload collective bargaining agreements and NeoHRMZ applies CBA-specific wage scales, seniority rules, and grievance workflows automatically.</div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- CTA -->
<section class="mfg-cta">
  <div class="container-wrapper">
    <h2 class="mfg-cta__h2">HR That Works as Hard<br>as Your Factory Floor</h2>
    <p class="mfg-cta__p">Join 600+ manufacturing companies running smarter workforce operations with NeoHRMZ. Zero downtime. Zero compliance gaps.</p>
    <div class="mfg-cta__actions">
      <a href="#" class="btn btn-white">Book a Plant Demo</a>
      <a href="#" class="btn btn-outline" style="color:#fff;border-color:rgba(255,255,255,0.3);">Download Manufacturing Guide</a>
    </div>
  </div>
</section>
<app-peopleflow-footer></app-peopleflow-footer>